import { DatePicker, Form, Modal, Select } from "antd";
import moment from "moment/moment";
import Scrollbars from "react-custom-scrollbars-2";
import { disabledDate } from "../../../../../../utilities/dateUtility";
import K from "../../../../../../utilities/constants";
import { ApprovalTotal } from "../../../approvalTotal";

export const CreateStatementModal = ({
  open,
  loading,
  threshold,
  clientExceptions,
  selectedRows,
  onCancel,
  onFinish,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title="Create Statement"
      className="s2-theme-style"
      open={open}
      destroyOnClose
      centered
      width={400}
      onOk={form.submit}
      onCancel={onCancel}
      okButtonProps={{ loading }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        rules={[{ required: true, message: "status is required!" }]}
      >
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "status is required!" }]}
        >
          <Select
            showSearch
            optionFilterProp="label"
            placeholder="Status"
            options={[
              { label: "Eligible", value: "ELIGIBLE" },
              { label: "Not Eligible", value: "NOT_ELIGIBLE" },
            ]}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
        </Form.Item>
        <Form.Item
          label="Due Date"
          name="deliveryDate"
          rules={[{ required: true, message: "due date is required!" }]}
          initialValue={moment()}
        >
          <DatePicker
            disabledDate={disabledDate}
            placeholder="Due Date"
            format={K.DateFormat.DashUSFormat}
          />
        </Form.Item>
        <ApprovalTotal
          thresholdType={threshold?.type}
          defaultBillingThreshold={threshold?.defaultValue}
          exceptions={clientExceptions || []}
          total={selectedRows?.total}
          exceptionsTotal={selectedRows?.exceptionsTotal}
          displayClientName
          renderExceptions={(exceptions) => (
            <Scrollbars autoHeight autoHeightMax={250}>
              {exceptions}
            </Scrollbars>
          )}
        />
      </Form>
    </Modal>
  );
};
